/* eslint-disable */
import { Routes, Route, Navigate } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import LoginPage from '../Pages/Login'
import LoginOtp from '../Pages/LoginOtp'
import ResetPassword from '../Pages/ResetPassword'
import PostLoginContainer from '../Pages/PostLoginContainer'
import SignUp from '../Pages/SignUp'
import ActivateAccountOTP from '../Pages/ActivateAccountOtp'
import LoginWithPassword from '../Pages/LoginWithPassword'
import LoginContainer from '../Pages/LoginContainer'
import LoginWithOTP from '../Pages/LoginWithOTP'
import TermsAndConditions from '../Pages/ipo/TermsAndConditions'
import LoadingSkeleton from '../Components/LoadingSkeleton'
import { EMandate } from '../Pages/EMandate'
import { ThirdPartyAddFunds } from '../Pages/tpfunds/ThirdPartyFunds'
import { TaxFiling } from '../Pages/Tax/TaxFiling'
import RetirementCalculator from '../Pages/Calculator/RetirementCalculatorNew'
import AdminRetirementCalculator from '../Pages/ActionPlan/Calculator/RetirementCalculatorNew'
import ErrorBoundary from '../Components/ErrorBoundary'
import { DematUser, PrivateRoute } from './PrivateRoute'
import MyPlan from '../Pages/MyPlan'
import { SSEProvider } from '../Provider/SSEProvider'
import MutualFunds from '../Pages/MutualFunds/MutualFunds'
import MFInvestments from '../Pages/MutualFunds/MFInvestments'
import MFDetails from '../Pages/MutualFunds/MFDetails'
import MFPlaceOrder from '../Pages/MutualFunds/MFPlaceOrder'
import MFOrders from '../Pages/MutualFunds/MFOrders'
import MFPayment from '../Pages/MutualFunds/MFPayment'
import MFPaymentRequest from '../Pages/MutualFunds/MFPaymentRequest'

import MFRedeem from '../Pages/MutualFunds/MFRedeem'
import BankPaymentResponse from '../Pages/MutualFunds/BankPaymentResponse'
import UserSource from '../Pages/UserSource'
import MFBasketPlaceOrder from '../Pages/MutualFundsBaskets/MFBasketPlaceOrder'
import MFBasketOneTimePayment from '../Pages/MutualFundsBaskets/MFBasketOneTimePayment'
import MFBasketBankPayment from '../Pages/MutualFundsBaskets/MFBasketBankPayment'
import MFsSIPs from '../Pages/MutualFunds/MFsSIPs'
import NewUser from '../Pages/FirstIdeas/NewUser'
import Homepage from '../Pages/FirstIdeas/Homepage'
import Returns from '../Pages/FirstIdeas/Returns'
import Questionaire from '../Pages/FirstIdeas/Questionaire'
import ActionPlan from '../Pages/ActionPlan/ActionPlan'
import Index from '../Pages/ActionPlan'
import AddPlan from '../Pages/ActionPlan/AddPlan'
import ActionNotification from '../Pages/ActionPlan/ActionNotification'
import DematHomepage from '../Pages/Homepage_v3/DematHomepage'
import UserActionPlan from '../Pages/FirstIdeas/UserActionPlan'
import PaymentConfirmation from '../Pages/FirstIdeas/PaymentConfirmation'
import GeneralSavingNew from '../Pages/Calculator/GeneralSavingNew'
import ActionOneTimePayment from '../Pages/FirstIdeas/ActionOneTimePayment'
import ActionPlanPaymentStatus from '../Pages/FirstIdeas/ActionPlanPaymentStatus'
import MFBasketRedeem from '../Pages/MutualFundsBaskets/MFBasketRedeem'
import FirstUserIdea from '../Pages/ActionPlan/FirstUserIdea'

import UserChats from '../Pages/ActionPlan/UserChats'
import UserHoldings from '../Pages/ActionPlan/UserHoldings'
import OneTimeMandate from '../Pages/ActionPlan/OneTimeMandate'
import InvestMoreOneTime from '../Pages/ActionPlan/InvestMoreOneTime'
import AdminPlaceOrder from '../Pages/ActionPlan/AdminPlaceOrder'
import InvestMoreSIP from '../Pages/ActionPlan/InvestMoreSIP'
import MFMandatePage from '../Pages/MutualFundsBaskets/MFMandatePage'

export default function RoutesConfig() {
  const FirstIdeasSection = lazy(() => import('../Pages/FirstIdeasSection'))
  const Plans = lazy(() => import('../Pages/Plans'))
  const ChildPlan = lazy(() => import('../Pages/Calculator/EducationCalculator'))
  // const RetirementPlan = lazy(() => import('../Pages/plan/RetirementPlan'))
  const WeddingPlan = lazy(() => import('../Pages/Calculator/WeddingCalculator'))
  const PurchasePlan = lazy(() => import('../Pages/Calculator/PurchaseCalculator'))
  const VehiclePlan = lazy(() => import('../Pages/Calculator/VehicleCalculator'))
  const VacationCalculator = lazy(() => import('../Pages/Calculator/VacationCalculator'))
  const PassionCalculator = lazy(() => import('../Pages/Calculator/PassionCalculator'))
  const JewelleryCalculator = lazy(() => import('../Pages/Calculator/JewelleryCalculator'))
  const EmergencyPlan = lazy(() => import('../Pages/Calculator/EmergencyCalculator'))
  const HomePurchaseCalculator = lazy(() => import('../Pages/Calculator/HomePurchaseCalculator'))
  const PostRetirementVacationPlan = lazy(() => import('../Pages/plan/PostRetirementVacationPlan'))
  // const Portfolio = lazy(() => import('../Pages/Portfolio'))
  const Holdings = lazy(() => import('../Pages/Portfolio/Holdings'))
  const Invest = lazy(() => import('../Pages/Portfolio/Invest'))
  // const Sips = lazy(() => import('../Pages/Sips'))
  const SipsNewScreen = lazy(() => import('../Pages/SipsNewScreen'))
  // const Activities = lazy(() => import('../Pages/Activities'))
  const Activities = lazy(() => import('../Pages/OrderHistory/LandingPage'))
  const Funds = lazy(() => import('../Pages/Funds'))
  const ThemeRisk = lazy(() => import('../Pages/ThemeRisk'))
  const ThemeRiskDetails = lazy(() => import('../Pages/ThemeRiskDetails'))
  // const ProfileOld = lazy(() => import('../Pages/Profile'))
  const Profile = lazy(() => import('../Pages/Profile/ProfileScreen'))
  const RiskAssessment = lazy(() => import('../Pages/RiskAssessment'))
  // const { EMandate } = lazy(() => import('../Pages/EMandate'))
  const ReferralPage = lazy(() => import('../Pages/ReferralPage'))
  const ReferralNewScreen = lazy(() => import('../Pages/ReferralNewScreen'))
  const EMandateMobile = lazy(() => import('../Pages/e-mandate-mobile/EMandateMobile'))
  const Policies = lazy(() => import('../Components/Information/Policies'))
  const Terms = lazy(() => import('../Components/Information/Terms'))
  const SupportPortalLogin = lazy(() => import('../Pages/SupportPortalLogin'))
  const EMandateSuccess = lazy(() => import('../Pages/EMandateSuccess'))
  const Insurance = lazy(() => import('../Pages/Insurance'))
  const PropertyPurchase = lazy(() => import('../Pages/plan/PropertyPurchase'))
  const IpoLandingPage = lazy(() => import('../Pages/ipo/IpoLandingPage'))
  const GoldBondsLandingPage = lazy(() => import('../Pages/GoldBonds/GoldBondsLandingPage'))
  const InvestmentsLandingPage = lazy(() => import('../Pages/MyInvestments/InvestmentsLandingPage'))
  const SupportPortal = lazy(() => import('../Pages/SupportPortal/SupportPortal'))

  // ADMIN
  const AdminChildPlan = lazy(() => import('../Pages/ActionPlan/Calculator/EducationCalculator'))
  const AdminWeddingPlan = lazy(() => import('../Pages/ActionPlan/Calculator/WeddingCalculator'))
  const AdminPurchasePlan = lazy(() => import('../Pages/ActionPlan/Calculator/PurchaseCalculator'))
  const AdminVehiclePlan = lazy(() => import('../Pages/ActionPlan/Calculator/VehicleCalculator'))
  const AdminVacationCalculator = lazy(() =>
    import('../Pages/ActionPlan/Calculator/VacationCalculator'),
  )
  const AdminPassionCalculator = lazy(() =>
    import('../Pages/ActionPlan/Calculator/PassionCalculator'),
  )
  const AdminJewelleryCalculator = lazy(() =>
    import('../Pages/ActionPlan/Calculator/JewelleryCalculator'),
  )
  const AdminEmergencyPlan = lazy(() =>
    import('../Pages/ActionPlan/Calculator/EmergencyCalculator'),
  )
  const AdminHomePurchaseCalculator = lazy(() =>
    import('../Pages/ActionPlan/Calculator/HomePurchaseCalculator'),
  )

  const AdminGeneralSavingCalculator = lazy(() =>
    import('../Pages/ActionPlan/Calculator/GeneralSavingCalculator'),
  )

  return (
    <Routes>
      <Route path='/' element={<LoginContainer />}>
        <Route index element={<Navigate to='/login' />} />
        <Route path='/login' element={<LoginPage />} />
        <Route path='/otp' element={<LoginOtp />} />
        <Route path='/sign-up' element={<SignUp />} />
        <Route path='/activate-account-otp' element={<ActivateAccountOTP />} />
        <Route path='/password' element={<LoginWithPassword />} />
        <Route path='/otp-login' element={<LoginWithOTP />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/user-source' element={<UserSource />} />
      </Route>
      <Route path='/process/payment/:uid' element={<ThirdPartyAddFunds />} />
      <Route
        path='/dashboard'
        element={
          <PrivateRoute>
            <SSEProvider>
              <PostLoginContainer />
            </SSEProvider>
          </PrivateRoute>
        }
      >
        <Route index element={<Homepage />} />
        <Route path='myplan' element={<MyPlan />} />
        <Route
          path='mutual-funds'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <MutualFunds />
            </Suspense>
          }
        >
          <Route path='investments' element={<MFInvestments />} />
          <Route path='orders' element={<MFOrders />} />
          <Route path='sips' element={<MFsSIPs />} />
        </Route>
        <Route path='mutual-funds/details' element={<MFDetails />} />
        <Route path='mutual-funds/place-order' element={<MFPlaceOrder />} />
        <Route path='mutual-funds/redeem/place-order' element={<MFRedeem />} />
        <Route path='mutual-funds/order-payment' element={<MFPayment />} />
        <Route path='mutual-funds/payment-request' element={<MFPaymentRequest />} />
        <Route path='mutual-funds/order-payment/status' element={<BankPaymentResponse />} />

        <Route
          path='support'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <SupportPortal />
            </Suspense>
          }
        />
        <Route
          path='firstideas'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <FirstIdeasSection />
            </Suspense>
          }
        />
        <Route
          path='plans'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <Plans />
            </Suspense>
          }
        />
        <Route
          path='educationplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <ChildPlan />
            </Suspense>
          }
        />

        <Route path='place-order' element={<MFBasketPlaceOrder />} />
        <Route path='one-time-payment' element={<MFBasketOneTimePayment />} />
        <Route path='one-time-payment/status' element={<MFBasketBankPayment />} />
        <Route path='basket/redeem/place-order' element={<MFBasketRedeem />} />

        <Route
          path='retirementplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <RetirementCalculator />
            </Suspense>
          }
        />
        <Route
          path='purchaseplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <PurchasePlan />
            </Suspense>
          }
        />
        <Route
          path='vehicleplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <VehiclePlan />
            </Suspense>
          }
        />
        <Route
          path='weddingplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <WeddingPlan />
            </Suspense>
          }
        />
        <Route
          path='emergencyplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <EmergencyPlan />
            </Suspense>
          }
        />
        <Route
          path='vacationplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <VacationCalculator />
            </Suspense>
          }
        />

        <Route
          path='generalsavingplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <GeneralSavingNew />
            </Suspense>
          }
        />

        <Route
          path='passionplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <PassionCalculator />
            </Suspense>
          }
        />
        <Route
          path='jewelleryplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <JewelleryCalculator />
            </Suspense>
          }
        />
        <Route
          path='homepurchase'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <HomePurchaseCalculator />
            </Suspense>
          }
        />
        <Route
          path='propertypurchase'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <PropertyPurchase />
            </Suspense>
          }
        />
        <Route
          path='postretirementvacationplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <PostRetirementVacationPlan />
            </Suspense>
          }
        />
        <Route
          path='portfolio'
          element={
            <ErrorBoundary>
              <Suspense fallback={<LoadingSkeleton />}>
                <InvestmentsLandingPage />
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='holdings'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <Holdings />
            </Suspense>
          }
        />
        <Route
          path='invest'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <Invest />
            </Suspense>
          }
        />
        {/* <Route
          path='sips'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <Sips />
            </Suspense>
          }
        /> */}
        <Route
          path='sips'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <SipsNewScreen />
            </Suspense>
          }
        />
        <Route
          path='activities'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <Activities />
            </Suspense>
          }
        />
        <Route
          path='funds'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <Funds />
            </Suspense>
          }
        />
        <Route
          path='theme'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <ThemeRisk />
            </Suspense>
          }
        />
        <Route
          path='ipo'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <IpoLandingPage />
            </Suspense>
          }
        />
        <Route
          path='goldbonds'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <GoldBondsLandingPage />
            </Suspense>
          }
        />
        <Route path='terms-and-conditions' element={<TermsAndConditions />} />
        <Route
          path='theme-details'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <ThemeRiskDetails />
            </Suspense>
          }
        />
        {/* <Route
          path='ProfileOld'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <ProfileOld />
            </Suspense>
          }
        /> */}
        <Route
          path='profile'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <DematUser>
                <Profile />
              </DematUser>
            </Suspense>
          }
        />
        <Route
          path='risk-assessment'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <RiskAssessment />
            </Suspense>
          }
        />
        <Route
          path='e-mandate'
          element={
            // <Suspense fallback={<LoadingSkeleton />}>
            <EMandate />
            // </Suspense>
          }
        />
        <Route
          path='refer'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <ReferralNewScreen />
            </Suspense>
          }
        />
        <Route
          path='insurance'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <Insurance />
            </Suspense>
          }
        />
        <Route
          path='tax-filing'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <TaxFiling />
            </Suspense>
          }
        />

        <Route path='newUser' element={<NewUser />} />
        {/* <Route path='firstTime' element={<Homepage />} /> */}
        <Route path='firstTime/returns' element={<Returns />} />
        <Route path='firstTime/questionnaire' element={<Questionaire />} />

        {/* NEW HOMEPAGE */}
        <Route path='dematDashboard' element={<DematHomepage />} />
        <Route path='firstTime/actionPlanUser' element={<UserActionPlan />} />
        <Route path='firstTime/confirmPayment' element={<PaymentConfirmation />} />
        <Route path='firstTime/confirmPayment' element={<PaymentConfirmation />} />
        <Route path='mutual-funds/mandate' element={<MFMandatePage />} />
        <Route path='actionplan/one-time-payment' element={<ActionOneTimePayment />} />
        <Route path='actionplan/one-time-payment/status' element={<ActionPlanPaymentStatus />} />
      </Route>
      {/* <Route path='/status' element={<PostLoginContainer />}>
        <Route index path='e-mandate' element={<EMandateSuccess />} />
      </Route> */}
      <Route
        index
        path='status/e-mandate'
        element={
          <Suspense fallback={<LoadingSkeleton />}>
            <EMandateSuccess />
          </Suspense>
        }
      />
      <Route path='/redirect' element={<PostLoginContainer />}>
        <Route
          index
          path='freshdesk'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <SupportPortalLogin />
            </Suspense>
          }
        />
      </Route>
      <Route
        path='sip/e-mandate'
        element={
          <Suspense fallback={<LoadingSkeleton />}>
            <EMandateMobile />
          </Suspense>
        }
      />
      <Route
        path='policies'
        element={
          <Suspense fallback={<LoadingSkeleton />}>
            <Policies />
          </Suspense>
        }
      />
      <Route
        path='terms'
        element={
          <Suspense fallback={<LoadingSkeleton />}>
            <Terms />
          </Suspense>
        }
      />

      <Route
        path='refer'
        element={
          <Suspense fallback={<LoadingSkeleton />}>
            <ReferralPage />
          </Suspense>
        }
      />

      <Route path='*' element={<Navigate replace to='/dashboard' />} />

      <Route
        path='6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin'
        element={<Index />}
      >
        <Route
          index
          element={
            <Navigate
              to='/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/actionPlan'
              replace
            />
          }
        />
        <Route path='actionPlan' element={<ActionPlan />} />
        <Route path='addPlan' element={<AddPlan />} />
        <Route path='addPlan/placeOrder' element={<AdminPlaceOrder />} />
        <Route path='firstUserIdeas' element={<FirstUserIdea />} />
        <Route path='userChats' element={<UserChats />} />
        <Route path='userHoldings' element={<UserHoldings />} />
        <Route path='oneTimeThroughMandate' element={<OneTimeMandate />} />
        <Route path='basket/investmore' element={<InvestMoreOneTime />} />
        <Route path='basket/add-sip' element={<InvestMoreSIP />} />
        {/* <Route path='userBasketHoldings' element={<UserBasketHoldings />} />
        <Route path='userBasketOrderHistory' element={<UserBasketOrderHistory />} />
        <Route path='userIndividualHoldings' element={<UserIndividualHoldings />} /> */}
        <Route path='notification' element={<ActionNotification />} />
        <Route
          path='educationplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminChildPlan />
            </Suspense>
          }
        />
        <Route
          path='retirementplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminRetirementCalculator />
            </Suspense>
          }
        />
        <Route
          path='purchaseplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminPurchasePlan />
            </Suspense>
          }
        />
        <Route
          path='vehicleplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminVehiclePlan />
            </Suspense>
          }
        />
        <Route
          path='weddingplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminWeddingPlan />
            </Suspense>
          }
        />
        <Route
          path='emergencyplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminEmergencyPlan />
            </Suspense>
          }
        />
        <Route
          path='vacationplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminVacationCalculator />
            </Suspense>
          }
        />
        <Route
          path='passionplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminPassionCalculator />
            </Suspense>
          }
        />
        <Route
          path='jewelleryplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminJewelleryCalculator />
            </Suspense>
          }
        />
        <Route
          path='homepurchaseplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminHomePurchaseCalculator />
            </Suspense>
          }
        />
        <Route
          path='generalsavingplan'
          element={
            <Suspense fallback={<LoadingSkeleton />}>
              <AdminGeneralSavingCalculator />
            </Suspense>
          }
        />
        <Route
          path='*'
          element={
            <Navigate
              replace
              to='/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/actionPlan'
            />
          }
        />
      </Route>
    </Routes>
  )
}
